import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, TrendingUp, Users, ArrowUpRight } from 'lucide-react';
import { useApp } from '../context/AppContext';

const Dashboard = () => {
    const { user, businesses, setActiveBusinessId } = useApp();
    const navigate = useNavigate();

    return (
        <div className="space-y-8 animate-fade-in">
            <div className="flex justify-between items-end">
                <div>
                    <h1 className="text-3xl font-bold text-slate-900">Dashboard</h1>
                    <p className="text-slate-500 mt-1">Overview of your ventures.</p>
                </div>
                <button onClick={() => navigate('/app/builder')} className="btn btn-primary">
                    <Plus className="mr-2" size={18} /> New Venture
                </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                    { label: 'Total Valuation', value: '$1.2M', change: '+12%', icon: TrendingUp },
                    { label: 'Active Users', value: '4,302', change: '+8%', icon: Users },
                    { label: 'Monthly Revenue', value: '$42k', change: '+24%', icon: ArrowUpRight },
                ].map((s, i) => (
                    <div key={i} className="card p-6">
                        <div className="flex justify-between items-start mb-4">
                            <div className="p-2 bg-indigo-50 rounded-lg text-primary"><s.icon size={20} /></div>
                            <span className="text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded">{s.change}</span>
                        </div>
                        <div className="text-2xl font-bold text-slate-900">{s.value}</div>
                        <div className="text-sm text-slate-500">{s.label}</div>
                    </div>
                ))}
            </div>

            {/* Ventures List */}
            <div>
                <h2 className="text-lg font-bold text-slate-900 mb-4">Your Businesses</h2>
                <div className="grid md:grid-cols-2 gap-6">
                    {businesses.map((biz) => (
                        <div key={biz.id} className="card p-6 hover:shadow-md transition-shadow cursor-pointer group"
                            onClick={() => { setActiveBusinessId(biz.id); navigate('/app/workspace'); }}>
                            <div className="flex justify-between items-start">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-gradient-to-br from-primary to-indigo-400 rounded-xl flex items-center justify-center text-white font-bold text-xl">
                                        {biz.name[0]}
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg group-hover:text-primary transition-colors">{biz.name}</h3>
                                        <p className="text-sm text-slate-500">{biz.tagline}</p>
                                    </div>
                                </div>
                                <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-bold uppercase">{biz.stage}</span>
                            </div>
                            <div className="mt-6 pt-4 border-t border-border flex justify-between items-center">
                                <div className="text-sm text-slate-500">Revenue: <span className="font-semibold text-slate-900">{biz.revenue}</span></div>
                                <div className="text-primary text-sm font-medium flex items-center">Manage <ArrowUpRight size={16} className="ml-1" /></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default Dashboard;
